export default __webpack_public_path__ + "137acd9.png";